import { useState, useEffect, useCallback } from 'react';
import ReportsService from '@/services/reportsService';
import { toast } from 'react-hot-toast';

console.log('🔥 useFinancialReports LOADED');

const useFinancialReports = (initialFilters = {}) => {
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState(null);
  const [branchSummary, setBranchSummary] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [filters, setFilters] = useState({
    period: initialFilters.period,
    startDate: initialFilters.startDate,
    endDate: initialFilters.endDate,
    branchId: initialFilters.branchId,
    offset: initialFilters.offset ?? 0,
    limit: initialFilters.limit ?? 25,
  });


  const fetchPaymentAnalysis = useCallback(async () => {
    try {
      setLoading(true);
      console.log('🚀 Fetching payment analysis...', filters);

      const response = await ReportsService.getPaymentAnalysis(filters);

      console.log('💰 Payment Analysis API RESPONSE 👉', response);


      setData(response?.data ?? []);
      setSummary(response?.summary ?? null);
      setBranchSummary(response?.branchSummary ?? []);

    } catch (err) {
      console.error(err);
      setError('Failed to load payment analysis');
      toast.error('Failed to load Payment Analysis report');
    } finally {
      setLoading(false);
    }
  }, [filters]);


  useEffect(() => {
    fetchPaymentAnalysis();
  }, [fetchPaymentAnalysis]);

  return {
    data,
    summary,
    branchSummary,
    loading,
    error,
    filters,
    setFilters,
    refreshPaymentAnalysis: fetchPaymentAnalysis,
  };
};

export default useFinancialReports;
